import { Box, FormControl, FormHelperText, Input, CircularProgress } from '@mui/joy';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { InlineEditButtons } from '@/components/InlineEditButtons';
import { useCreateSubcategoryMutation } from '../api';
import { subcategorySchema } from '../schema';
import { getCategoryErrorMessage } from '../utils';

export function AddSubcategoryForm({ categoryId, onSave, onCancel }) {
  const [createSubcategory] = useCreateSubcategoryMutation();
  
  const { register, handleSubmit, formState, reset, setError } = useForm({
    resolver: yupResolver(subcategorySchema),
    defaultValues: { name: '' }
  });

  const { errors, isSubmitting } = formState;
  const nameError = errors.name;

  const onSubmit = async (data) => {
    try {
      const result = await createSubcategory({
        data: {
          category_id: categoryId,
          name: data.name.trim()
        }
      }).unwrap();
      
      reset();
      onSave(result.data);
    } catch (error) {
      const errorMessage = getCategoryErrorMessage(error, 'create', 'subcategory');
      setError('name', { type: 'server', message: errorMessage });
    }
  };

  const handleCancel = () => {
    reset();
    onCancel();
  };

  const handleKeyDown = (e) => {
    if (isSubmitting) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit(onSubmit)();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, p: 0.5, px: 1, borderRadius: 'sm', bgcolor: 'background.level1' }}>
      <FormControl error={!!nameError} sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Input
            {...register('name')}
            onKeyDown={handleKeyDown}
            autoFocus
            size="sm"
            disabled={isSubmitting}
            placeholder="Subcategory name"
            sx={{ flexGrow: 1, fontSize: '14px', opacity: isSubmitting ? 0.6 : 1 }}
            endDecorator={isSubmitting ? <CircularProgress size="sm" /> : null}
          />
          <InlineEditButtons onSave={handleSubmit(onSubmit)} onCancel={handleCancel} disabled={isSubmitting} />
        </Box>
        {nameError && <FormHelperText sx={{ ml: 0, mt: 0.5 }}>{nameError.message}</FormHelperText>}
      </FormControl>
    </Box>
  );
}

